import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import axios from 'axios'
import './assets/tailwind.css'
// import VueMoment from '/vue-moment'
loadFonts()

// Global session guard: if the API ever rejects a request as unauthorized
// (expired/invalid token), clear the stored session and bounce to login.
// The login request itself is exempted so bad-credentials errors surface
// normally on the login screen.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error && error.response && error.response.status;
    const url = (error && error.config && error.config.url) || '';
    const isLoginCall = url.indexOf('/login') !== -1;
    if ((status === 401 || status === 419) && !isLoginCall) {
      localStorage.removeItem('token');
      localStorage.removeItem('user_data');
      if (router.currentRoute.value.name !== 'login') {
        router.push({ name: 'login' });
      }
    }
    // No response at all = network/server unreachable; let App.vue surface a
    // brief "can't reach the server" banner.
    if (!error.response) {
      try { window.dispatchEvent(new CustomEvent('int:neterror')); } catch (e) { /* ignore */ }
    }
    return Promise.reject(error);
  }
);

createApp(App).use(router)
  .use(vuetify)
  .mount('#app')
